
import React from 'react';
import UserManagement from 'features/administrativo/components/UserManagement';

const ConfiguracoesUsuarios = () => {
  return <UserManagement />;
};

export default ConfiguracoesUsuarios;
